export const capitalize = (value: string | undefined) => {
    if (!value) {
        return value;
    }
    return value.slice(0, 1).toUpperCase() + value.slice(1).toLowerCase();
};
